import {
    userPurchasedPassMsg,
    confirmationCodeRedeemedMsg,
    showSoldOutMsg,
    buyPassToEnterTheShowMsg,
    freePreviewStartedMsg,
    showVODStateMsg,
    freePreviewEndedMsg,
    showHasNotEndedAndBannerHasNoErrors,
    showIsNotSoldOutAndBannerHasNoErrors,
    bannerHasNoErrors,
    redeemOnlyMsg,
    userAccessPrivateEvent,
} from '.'
import { AppThunk } from 'redux/store'

export const onUserPurchasedPassMsg = (): AppThunk => async (dispatch, getState) => {
    if (showHasNotEndedAndBannerHasNoErrors(getState())) {
        dispatch(userPurchasedPassMsg())
    }
}

export const onBuyPassToEnterTheShowMsg = (): AppThunk => async (dispatch, getState) => {
    if (bannerHasNoErrors(getState())) {
        dispatch(buyPassToEnterTheShowMsg())
    }
}

export const onShowSoldOutMsg = (): AppThunk => async (dispatch, getState) => {
    if (bannerHasNoErrors(getState())) {
        dispatch(showSoldOutMsg())
    }
}

export const onConfirmationCodeRedeemedMsg = (): AppThunk => async (dispatch, getState) => {
    if (showHasNotEndedAndBannerHasNoErrors(getState())) {
        dispatch(confirmationCodeRedeemedMsg())
    }
}

export const onFreePreviewStartedMsg = (): AppThunk => async (dispatch, getState) => {
    if (showIsNotSoldOutAndBannerHasNoErrors(getState())) {
        dispatch(freePreviewStartedMsg())
    }
}

export const onFreePreviewEndedMsg = (): AppThunk => async (dispatch, getState) => {
    if (showIsNotSoldOutAndBannerHasNoErrors(getState())) {
        dispatch(freePreviewEndedMsg())
    }
}

export const onShowVODStateMsg = (): AppThunk => async (dispatch, getState) => {
    if (bannerHasNoErrors(getState())) {
        dispatch(showVODStateMsg())
    }
}

export const onRedeemOnlyMsg = (): AppThunk => async (dispatch, getState) => {
    if (bannerHasNoErrors(getState())) {
        dispatch(redeemOnlyMsg())
    }
}

export const onUserAccessPrivateEvent = () => async (dispatch, getState) => {
    if (showHasNotEndedAndBannerHasNoErrors(getState())) {
        dispatch(userAccessPrivateEvent())
    }
}
